require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-j-kevin-ryan-financial-center-chief-executive-officer-retires.json") })
        }
      }, "path---es-articles-j-kevin-ryan-financial-center-chief-executive-officer-retires");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-j-kevin-ryan-financial-center-chief-executive-officer-retires!./.cache/json/es-articles-j-kevin-ryan-financial-center-chief-executive-officer-retires.json
// module id = 2215
// module chunks = 231608221292675